import { Component } from '@angular/core';

@Component({
  selector: 'app-acik-riza-metni',
  templateUrl: './acik-riza-metni.component.html'
})
export class AcikRizaMetniComponent {
  /**
   * Rıza kayıtlarının hangi metin sürümüne dayandığı izlenebilmelidir:
   * rızanın kapsamını değiştiren her düzenlemede `version` yükseltilir,
   * yalnızca yazım düzeltmelerinde `lastUpdated` güncellenir.
   */
  readonly version = 'v1.0';
  readonly lastUpdated = { iso: '2026-07-27', label: '27 Temmuz 2026' };
}
